import { render, staticRenderFns } from "./sider_trigger.vue?vue&type=template&id=084e795e&scoped=true"
import script from "./sider_trigger.vue?vue&type=script&lang=js"
export * from "./sider_trigger.vue?vue&type=script&lang=js"
import style0 from "./sider_trigger.vue?vue&type=style&index=0&id=084e795e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084e795e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('084e795e')) {
      api.createRecord('084e795e', component.options)
    } else {
      api.reload('084e795e', component.options)
    }
    module.hot.accept("./sider_trigger.vue?vue&type=template&id=084e795e&scoped=true", function () {
      api.rerender('084e795e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/components/layout/header/sider_trigger/sider_trigger.vue"
export default component.exports